import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { AdsGETApi, AdsGETApiAuth, AdsPOSTApi, ExamBlockPlaceHolder } from '../../../Constant/api';
import { slugs } from '../../../Constant/slugs';
import { logout } from '../../../redux/action';

import { ExamBlock } from '../ExamBlock';
import './Exam.css'

const slug = {
  "ubt": "UBT",
  "cbt-chemical": "CBT CHEMICAL",
  "cbt-electronics-electricity": "CBT ELECTRONIC ELECTRCITY",
  "cbt-food-related": "CBT FOOD RELATED",
  "cbt-mechinery-molding": "CBT MACHINERY,MOLDING",
  "cbt-metal": "CBT METAL",
  "cbt-pulp-paper-wood": "CBT PULP PAPER WOOD",
  "cbt-rubber": "CBT RUBBER",
  "cbt-textile-sewing": "CBT TEXTILE SEWING"
}
export default function AllPaidExamList() {
  const [AllExamList1, setAllExamList1] = React.useState([]);
  const [reload, setReload] = React.useState(false)
  const [pagesLength, setPagesLength] = React.useState("1");
  const [pages, setPages] = React.useState(1);
  const dispatch = useDispatch()

  const fetchExam = (setAllExamList, perPage) => {
    setReload(true)
    AdsGETApi({
      ...perPage,
    }, slugs.db_slug_demo_exam)
      .then((res) => {
        setAllExamList(res.data)
        setReload(false)
        setPagesLength(res.headers["x-wp-totalpages"])
        console.log(res.data.length)
      })
      .catch(err => {
        console.log(err)
        console.log(err.response.data)
        if (err.message.includes("Request failed with status code 500"))
          dispatch(logout())
      })
  }
  let myarray = []
  for (let i = 0; i < pagesLength; i++)
    myarray.push(
      <div key={i} style={{ margin: "3px" }}>
        <button onClick={() => {
          setPages(i + 1)
          setAllExamList1([])
          fetchExam(setAllExamList1, { page: i + 1, per_page: 20, order: "asc" })
        }}
          style={{ border: "0", padding: "7px", backgroundColor: pages == i + 1 ? "#0d02a6" : "#f00", color: "#fff", borderRadius: "5px" }}
        >
          {i + 1}
        </button>
      </div>
    )
  const location = useLocation()
  useEffect(() => {
    if (!location.pathname.slice(11).includes("topik"))
      fetchExam(setAllExamList1, {
        per_page: 200, order: "asc",
        _fields: "id,title,slug,meta.available_unavailable,meta.exam_question_block_student,meta.featured_image",
        "filter[meta_query][1][key]": "available_unavailable",
        "filter[meta_query][1][value][0]": `Available`,
        "filter[meta_query][1][compare]": "=",
      })
    else
      setReload(false)
  }, [])

  return (
    <main className="exam-list-page">
      <section className="exam-list-container">
        <div className="exam-list-header">
          <div>
            <span className="exam-list-badge">
              Practice Tests
            </span>

            <h1>All Exams</h1>

            <p>
              Select an available exam below and start your practice test.
            </p>
          </div>

          <div className="exam-count">
            <strong>{AllExamList1.length}</strong>
            <span>Free Exams</span>
          </div>
        </div>

        {AllExamList1.length > 0 ? (
          <div className="exam-card-grid">
            {AllExamList1.map((item, index) => (
              <article
                key={item.id || index}
                className="exam-list-card"
              >
                <div className="exam-card-number">
                  {String(index + 1).padStart(2, "0")}
                </div>

                <div className="exam-card-content">
                  <h2
                    className="exam-card-title"
                    dangerouslySetInnerHTML={{
                      __html: item.title?.rendered || "Untitled Exam",
                    }}
                  />

                  <div className="exam-card-meta">
                    <span>
                      <i
                        className="fa fa-file-text-o"
                        aria-hidden="true"
                      />
                      Practice Exam
                    </span>

                    <span>
                      <i
                        className="fa fa-check-circle-o"
                        aria-hidden="true"
                      />
                      Free
                    </span>
                  </div>
                </div>

                <Link
                  className="start-exam-button"
                  to={`${slugs.start_demo_exam}/${item.slug}`}
                >
                  <span>Start Exam</span>
                  <i
                    className="fa fa-arrow-right"
                    aria-hidden="true"
                  />
                </Link>
              </article>
            ))}
          </div>
        ) : (
          !reload && (
            <div className="exam-empty-state">
              <div className="exam-empty-icon">
                <i
                  className="fa fa-file-text-o"
                  aria-hidden="true"
                />
              </div>

              <h2>No exams available</h2>

              <p>
                There are currently no available practice exams.
              </p>
            </div>
          )
        )}

        {pagesLength !== "1" && (
          <div className="exam-pagination">
            {Array.from(
              { length: Number(pagesLength) },
              (_, index) => (
                <button
                  type="button"
                  key={index}
                  className={
                    pages === index + 1
                      ? "exam-page-button active"
                      : "exam-page-button"
                  }
                  onClick={() => {
                    setPages(index + 1);
                    setAllExamList1([]);

                    fetchExam(setAllExamList1, {
                      page: index + 1,
                      per_page: 20,
                      order: "asc",
                    });
                  }}
                >
                  {index + 1}
                </button>
              )
            )}
          </div>
        )}
      </section>

      {reload && (
        <div className="exam-loader-overlay">
          <div className="exam-loader-content">
            <div className="exam-loader" />
            <span>Loading exams...</span>
          </div>
        </div>
      )}
    </main>
  );
  // return (
  //   <div style={{ backgroundColor: "#eee", minHeight: "80vh" }}>
  //     <div className="row">
  //       {/* <div className="col-1"></div> */}
  //       <div className="form-view mt-3">
  //         <div className="row" style={{ margin: "10px" }}>
  //           <h2>All Exams</h2>
  //           {AllExamList1.map((item, index) => (
  //             <div key={index} className=" center" style={{ padding: "0 5px" }}>
  //               {/* <ExamBlock item={item} examSlug={slugs.start_demo_exam} /> */}
  //               <div style={{
  //                 padding: "5px", margin: "5px 0px", border: "1.5px solid #bbb",
  //                 borderRadius: "5px",
  //               }}>
  //                 <div className='row'>
  //                   <div style={{ width: "75%", alignContent: 'center', textAlign: "left" }}>
  //                     {item.title.rendered}&nbsp;
  //                   </div>
  //                   <div style={{ width: "20%", alignContent: "center" }}>
  //                     <div style={{ width: "100%", display: 'flex', justifyContent: 'center', }}>
  //                       <div style={{ backgroundColor: "#000", borderRadius: "10px", padding: "5px 10px" }}>
  //                         <Link
  //                           to={`${slugs.start_demo_exam}/${item.slug}`}
  //                         >
  //                           <div style={{ color: "#fff", fontSize: "12px" }}>
  //                             Start Exam
  //                           </div>
  //                         </Link>
  //                       </div>
  //                     </div>
  //                   </div>
  //                 </div>
  //               </div >
  //             </div>
  //           ))}
  //         </div>

  //         {pagesLength !== "1" &&
  //           <div className="" style={{ display: 'flex', flexDirection: 'row', margin: 10 }}>
  //             {myarray}
  //           </div>
  //         }
  //       </div>
  //     </div>

  //     {reload &&
  //       <div className="modal" style={{ padding: "50vw" }}>
  //         <div className="dot-pulse"></div>
  //       </div>
  //     }
  //   </div>
  // )
}